import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Stagger, itemVariant } from "../components/Reveal";
import { OTHER_PLASTICS, SERVICES } from "../data/content";

export default function OtherPlastics() {
  const { t, lang } = useLang();
  return (
    <>
      <Seo
        title="Andere technische Kunststoffe – POM, PC, Superabsorber & Wachs | PlastoNord"
        description="Neben TPU liefert PlastoNord NORDFORM® POM, NORDLON® PC, NORDSAP® Superabsorber und NORDVAX® Tec-Wachs – technisches Kunststoffgranulat für die Industrie."
        path="/andere-kunststoffe"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Produkte", path: "/produkte" }, { name: lang === "de" ? "Andere Kunststoffe" : "Other plastics", path: "/andere-kunststoffe" }]}
      />
      <PageHero overline={lang === "de" ? "Weitere technische Kunststoffe" : "Other technical plastics"}
        title={lang === "de" ? "Mehr als TPU: POM, PC, Superabsorber & Wachs" : "Beyond TPU: POM, PC, superabsorbent & wax"}
        subtitle={lang === "de" ? "Ergänzend zu unserem TPU-Kernsortiment liefern wir weitere technische Kunststoffgranulate für spezifische Anforderungen." : "Complementing our core TPU range, we supply further technical plastic granules for specific requirements."} />
      <section className="py-24">
        <div className="pn-container space-y-8">
          {OTHER_PLASTICS.map((p) => { const c = lang === "de" ? p.de : p.en; return (
            <Stagger key={p.sku} className="pn-card grid gap-8 p-8 md:grid-cols-[1fr_1.2fr]">
              <motion.div variants={itemVariant}>
                <span className="font-mono text-xs text-[#E2611C]">{p.material}</span>
                <h2 className="mt-2 font-head text-2xl font-semibold text-[#16181D]">{c.name}</h2>
                <p className="text-[#4a4d52]">{c.t}</p>
                <p className="mt-4 leading-relaxed text-[#4a4d52]">{c.d}</p>
                <p className="mt-4 text-sm text-[#4a4d52]"><span className="font-medium text-[#16181D]">{lang === "de" ? "Varianten" : "Variants"}:</span> {c.variants}</p>
                <Link to="/kontakt" className="btn-primary mt-6 !px-5 !py-2 text-sm">{t("cta.request")} <ArrowRight size={15} /></Link>
              </motion.div>
              <motion.ul variants={itemVariant} className="grid content-start gap-3 sm:grid-cols-2">
                {c.props.map((pr) => (
                  <li key={pr} className="flex items-start gap-2.5 rounded-lg bg-[#f6f8fb] p-3 text-sm text-[#16181D]">
                    <Check size={16} className="mt-0.5 shrink-0 text-[#E2611C]" /> {pr}
                  </li>
                ))}
              </motion.ul>
            </Stagger>
          ); })}
        </div>
      </section>

      <section className="bg-[#16181D] py-20 text-white grain">
        <div className="pn-container">
          <p className="overline">{lang === "de" ? "Service" : "Services"}</p>
          <h2 className="mt-3 font-head text-3xl font-light tracking-tight md:text-4xl">{lang === "de" ? "Engagierte Serviceleistungen" : "Dedicated services"}</h2>
          <Stagger className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {SERVICES.map((s) => { const c = lang === "de" ? s.de : s.en; return (
              <motion.div key={c.t} variants={itemVariant} className="rounded-xl border border-white/10 bg-white/5 p-6 backdrop-blur">
                <h3 className="font-head text-lg font-semibold">{c.t}</h3>
                <p className="mt-2 text-sm text-white/70">{c.d}</p>
              </motion.div>
            ); })}
          </Stagger>
        </div>
      </section>
    </>
  );
}
